import React from "react";


const BinDetailComp = (props) => {
    return(
        <div className="mb-5">
            <h5 className="text-lg text-white font-bold mb-1.5">{props.heading}</h5>
            <div className="bg-gray-800 p-3.5 rounded-lg">
                <p className="text-md text-white">{props.detail}</p>
            </div>
        </div>
    )
}

export default BinDetailComp